import { Dialog } from '@mui/material';
import AIChatbot from '../AIChatbot';

const AIModal = ({ open, onClose, prompt, data }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: '12px',
        overflow: 'hidden',
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
      },
    }}
  >
    <AIChatbot
      open={open}
      onClose={onClose}
      autoSendPrompt={prompt}
      autoSendJsonData={data}
      modalMode
    />
  </Dialog>
);

export default AIModal;
